import { SgwtMiniFooterHTMLElement } from '@sgwt/sgwt-widgets-react';
import { useEffect, useState } from 'react';

export function useMiniFooterWidget() {
  const [miniFooterElement, setMiniFooterElement] = useState<SgwtMiniFooterHTMLElement | null>(null);

  useEffect(() => {
    setMiniFooterElement(document.querySelector<SgwtMiniFooterHTMLElement>('sgwt-mini-footer'));
  }, []);

  return miniFooterElement;
}
